import { cn } from '@/lib/utils';

type ContainerProps = {
  children: React.ReactNode;
  as?:
    | 'div'
    | 'section'
    | 'article'
    | 'main'
    | 'aside'
    | 'header'
    | 'footer'
    | 'nav';
  centered?: boolean;
  className?: string;
  hasPadding?: boolean;
};

/**
 * Container component
 * @param children - The content to be rendered inside the container
 * @param as - The HTML element to render the container as
 * @param className - Additional CSS classes to apply to the container
 * @param centered - Whether to center the container
 * @param hasPadding - Whether to add padding to the container
 */
export default function Container({
  children,
  as: Component = 'div',
  className,
  centered = true,
  hasPadding = true,
}: ContainerProps) {
  return (
    <Component
      className={cn(
        'container max-w-[90rem]',
        hasPadding && 'px-4 sm:px-6 md:px-[3.125rem]',
        centered && 'mx-auto',
        className,
      )}
    >
      {children}
    </Component>
  );
}
